import { put, take, takeLatest, call } from 'redux-saga/effects';

import contactService from 'services/contactService';

import { createPaymentTerms, save, types } from './actions';
import { MODES } from './constants';

export default function* root() {
  yield takeLatest(types.CREATE_PAYMENT_TERMS_REQUEST, watchCreatePaymentTerms);
  yield takeLatest(types.PAYMENT_TERMS_DRAWER_OPEN, watchPaymentTermsDrawer);
  yield takeLatest(types.SAVE_REQUEST, watchSaveAccount);
}

function* watchCreatePaymentTerms({ payload }) {
  try {
    const { label, period } = payload;
    const response = yield call(contactService.paymentTerms.create, {
      label,
      period,
    });
    yield put(createPaymentTerms.success({ paymentTerm: response }));
  } catch (error) {
    yield put(createPaymentTerms.error(error));
  }
}

// waits for a response from the custom payment terms modal
// to update the customers form
function* watchPaymentTermsDrawer(action) {
  try {
    const { cb } = action.payload;
    const successAction = yield take(types.CREATE_PAYMENT_TERMS_SUCCESS);
    cb(successAction.payload.paymentTerm.id);
  } catch (error) {
    console.error('ERROR watching pament terms drawer: ', error);
  }
}

function* watchSaveAccount(action) {
  try {
    const {
      address1,
      address2,
      city,
      country,
      creditCardsEnabled,
      creditLine,
      erpCode,
      name,
      notes,
      paymentTermsId,
      phone,
      phoneExt,
      postalCode,
      purchaseOrders,
      salespersonId,
      state,
      taxExempt,
      taxRate,
      type,
      url,
      accountId,
      mode,
    } = action.payload;

    let address = undefined;
    let addressId = undefined;
    if (address1) {
      address = {
        address1,
        address2,
        city,
        country,
        postalCode,
        state,
      };
    } else {
      addressId = null;
    }

    const requestData = {
      soldToAddress: address,
      soldToAddressId: addressId,
      creditCardsEnabled,
      creditLine: creditLine || null,
      erpCode,
      name,
      notes,
      paymentTermsId,
      phone,
      phoneExt,
      purchaseOrders,
      salespersonId,
      taxExempt,
      taxRate: taxRate || null,
      type,
      url,
    };

    let account;
    if (mode == MODES.CREATE) {
      account = yield call(contactService.accounts.create, requestData);
    } else {
      account = yield call(
        contactService.accounts.update,
        accountId,
        requestData,
      );
    }

    yield put(save.success({ account }));
    yield call(action.payload.onSaveCallback, { account });
    yield call(action.payload.onClose);
  } catch (error) {
    yield put(save.error(error));
  }
}
